import { render, staticRenderFns } from "./HeroBackground.vue?vue&type=template&id=1f87b2bd&"
import script from "./HeroBackground.vue?vue&type=script&lang=js&"
export * from "./HeroBackground.vue?vue&type=script&lang=js&"
import style0 from "./HeroBackground.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports